import React, { FC } from 'react';
import Spinner from 'react-bootstrap/Spinner';

import './style.scss';

interface IActionButtonProps {
  disabled?: boolean;
  isLoading?: boolean;
  label: string;
  onClick: () => void;
}

const ActionButton: FC<IActionButtonProps> = ({ disabled = false, isLoading = false, label, onClick }) => {
  const clickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onClick();
  };

  return (
    <div className="prime-hint">
      <button
        type="button"
        className="recover-btn"
        onClick={clickHandler}
        disabled={disabled || isLoading}
      >
        {isLoading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        ) : (
          label
        )}
      </button>
    </div>
  );
};

export default ActionButton;
